var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-pagination",
    {
      staticClass: "cursor-pagination",
      attrs: {
        layout: "slot, sizes, prev, next",
        "current-page": _vm.pagerCurrent,
        "page-count": _vm.pagerPageCount,
        "page-size": _vm.pageSize,
        "page-sizes": _vm.pageSizes,
        background: _vm.background,
      },
      on: {
        "update:currentPage": function ($event) {
          _vm.pagerCurrent = $event
        },
        "update:current-page": function ($event) {
          _vm.pagerCurrent = $event
        },
        "prev-click": _vm.onPrevClick,
        "next-click": _vm.onNextClick,
        "size-change": _vm.onSizeChange,
      },
    },
    [
      _vm._t("default", [
        _c("span", { staticClass: "cursor-pagination__total" }, [
          _vm._v("共 " + _vm._s(_vm.total) + " 条"),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }